<script setup lang="ts">
import { formatDateTime } from '@/utils/formatters'
import { SHARED_ANCHORS } from '../scenarios/shared/anchors'
import type { IOnboardingDemoChat } from '../types/IOnboardingDemoChat'

/**
 * Учебная переписка демо-записи онбординга. Показывается в правой панели формы вместо Matrix-чата:
 * у демо-записи нет комнаты, а сообщения приходят вместе с демо-данными раздела.
 */
defineProps<{
  chat: IOnboardingDemoChat
}>()
</script>

<template>
  <div
    class="onboarding-demo-chat d-flex flex-column h-100 bg-surface"
    :data-onboarding="SHARED_ANCHORS.demoChat"
  >
    <div class="text-subtitle-1 font-weight-medium px-6 pt-6 pb-3 border-b">
      {{ chat.title }}
    </div>
    <div class="d-flex flex-column ga-4 pa-6 overflow-y-auto">
      <div
        v-for="message in chat.messages"
        :key="message.id"
        class="d-flex flex-column ga-1"
      >
        <div class="d-flex align-center ga-2 text-caption text-medium-emphasis">
          <span class="font-weight-medium text-high-emphasis">{{ message.author_name }}</span>
          <span>{{ message.author_role }}</span>
          <span class="ms-auto">{{ formatDateTime(message.created_at) }}</span>
        </div>
        <div class="onboarding-demo-chat__text text-body-2 rounded-lg pa-3">
          {{ message.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.onboarding-demo-chat__text {
  background: rgba(var(--v-theme-on-surface), var(--v-hover-opacity));
  white-space: pre-line;
}
</style>
